import { render } from "./Contacts.vue?vue&type=template&id=3091d1d8&scoped=true"
const script = {}

import "./Contacts.vue?vue&type=style&index=0&id=3091d1d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3091d1d8"

export default script